import { render, staticRenderFns } from "./CentralAgencias.vue?vue&type=template&id=47d6d29b&scoped=true"
import script from "./CentralAgencias.vue?vue&type=script&lang=js"
export * from "./CentralAgencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d6d29b",
  null
  
)

export default component.exports